/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import IProjectsResolver from "@models/IProjectsResolver.models";
import { Development } from "@models/development.model";
import { Project } from "@models/project.model";
import { DevelopmentService } from "@services/development.service";

// eslint-disable-next-line no-var
declare var $: any;

@Component({
  selector: "app-projects",
  templateUrl: "./projects.component.html",
  styleUrls: ["./projects.component.scss"],
})
export class ProjectsComponent implements OnInit {
  mapZoomLevel = 9;
  project!: Project;
  development!: Development;
  budget = 0;
  fundingSource: string[] = [];
  isMultiDevelopment = false;
  filteredMultiDevelopment: Development[] = [];
  toBeDetermined = "To Be Determined";
  projectStatus: string[] = [];
  isPlannedProject = false;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public developmentService: DevelopmentService,
  ) {}

  ngOnInit(): void {
    const data: IProjectsResolver = this.activatedRoute.snapshot.data["projectData"];

    this.project = data.project;
    this.development = data.development;
    try {
      const link = document.querySelector(".language-selector a") as HTMLAnchorElement;
      if (link) {
        link.href = `${window.location}#`;
      }
    } catch (error) {
      console.log(error);
    }
    if (this.project !== undefined) {
      this.getFundingSource();
      this.getBudget();
      this.checkMultiDevelopment();
      this.getFilteredMultiDevelopment();
      this.getProjectstatus();
    }

    if (screen.width < 500) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    // console.log(this.project);
  }

  getFilteredMultiDevelopment(): void {
    if (this.isMultiDevelopment)
      this.filteredMultiDevelopment = this.developmentService
        .getItems()
        .filter(({ id }) => this.project.otherDevelopments.includes(id));
  }
  checkMultiDevelopment() {
    this.isMultiDevelopment = this.project.otherDevelopments.length > 1 ? true : false;
  }
  getFundingSource(): void {
    this.fundingSource?.push(...this.project.funding.flatMap((x) => x.fundingCategory));
    this.fundingSource = this.fundingSource?.filter((item, pos, ar) => ar.indexOf(item) === pos);
  }

  getBudget(): void {
    this.budget = this.project.projectTotalBudget;
    // this.budget = this.project.funding
    //   .flatMap((x) => x.totalBudget)
    //   .reduce((acc, cur) => acc + Number(cur), 0);
  }

  getProjectstatus(): void {
    this.projectStatus.push(this.project.projectStatus);

    this.projectStatus.push(
      ...this.project.schedule
        .filter((x) => Number(x.percentageCompleted) < 100 && Number(x.percentageCompleted) !== 0)
        .flatMap((v) => v.masterTaskName),
    );

    this.projectStatus = this.projectStatus.filter((item, pos, ar) => ar.indexOf(item) === pos);
    this.isPlannedProject = this.projectStatus.every((x) => x.toLocaleLowerCase() === "planned");
  }

  closeModal(): void {
    $("#contactModal").modal("toggle");
  }

  printPDF(): void {
    window.print();
  }
}
